export const INWARD_OUTWARD_TEXT_MAX = 500;
export const INWARD_OUTWARD_PAGE_SIZE = 50;

export const ALLOWED_UPLOAD_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/jpeg",
  "image/png",
  "image/webp",
];

export const INVALID_UPLOAD_TYPE_MESSAGE =
  "Only PDF, DOC, DOCX, JPG, PNG, and WebP files are allowed.";

export function validateInwardOutwardTextField(value, label) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return `${label} is required`;
  if (trimmed.length > INWARD_OUTWARD_TEXT_MAX) {
    return `${label} cannot exceed ${INWARD_OUTWARD_TEXT_MAX} characters`;
  }
  return "";
}
